import messageResource from '../../../../messageResource'

export default function LeaveCSVPreviewColumnsStrategy() {}

LeaveCSVPreviewColumnsStrategy.prototype.init = function ()
{
    return this;
};

LeaveCSVPreviewColumnsStrategy.prototype.getNumOfDataColumns = function ()
{
    // abstract
};

LeaveCSVPreviewColumnsStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    // abstract
};

LeaveCSVPreviewColumnsStrategy.prototype.addDataCells = function ( row )
{
    for( let i = 0; i < this.getNumOfDataColumns(); i++ )
        ReportPreviewUtils.addCSVTimeValueCell( row );
};

LeaveCSVPreviewColumnsStrategy.prototype.addLeaveTypeCells = function ( row, numOfCells )
{
    for( var i = 0; i < numOfCells; i++ )
        this.addLeaveTypeCell( row );
};

LeaveCSVPreviewColumnsStrategy.prototype.addLeaveTypeCell = function ( row )
{
    ReportPreviewUtils.addCell( row, messageResource.getMessage("report.common.leave_type") );
};

LeaveCSVPreviewColumnsStrategy.prototype.addLeaveTypeTotalCell = function ( row )
{
    ReportPreviewUtils.addCell( row, messageResource.getMessage("report.leaves.total.html_csv") );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/leave/LeaveCSVPreviewColumnsStrategy.js